import React from "react";
import styles from "../../../../components/Statistics.module.scss";
import { gql, useQuery } from "@apollo/client";
import { Loading, Progress } from "components";
import { isNumber } from "lodash-es";

export default function Page({ params: { id } }) {
  return (
    <div>
      <ClassProgress assignment={{ id }} />
    </div>
  );
}

function ClassProgress({ assignment }) {
  const { data, loading, error } = useQuery(QUERY, {
    variables: { id: assignment.id },
  });

  // TODO: move to below
  if (loading) return <Loading />;
  if (error) return <div>Network error</div>;

  const list = [
    {
      title: "Upload a spherical panorama",
      progress: data.assignment.stats.progress1 * 100,
      average: "",
    },
    {
      title: "Input a narration script",
      progress: data.assignment.stats.progress2 * 100,
      average: "",
    },
    {
      title: "Add music audio",
      progress: data.assignment.stats.progress3 * 100,
      average: "",
    },
    {
      title: "Add narration audio",
      progress: data.assignment.stats.progress4 * 100,
      average: "",
    },
    {
      title: "Add story scenes",
      average: data.assignment.stats.average1,
    },
    {
      title: "Add media objects",
      average: data.assignment.stats.average2,
    },
    {
      title: "Add tour buttons",
      average: data.assignment.stats.average3,
    },
  ];

  return (
    <div className="px-3">
      <table className={styles.table}>
        <thead>
          <tr>
            <th className="text-left">Components</th>
            <th width="330" className="text-center">
              Class progess
            </th>
          </tr>
        </thead>
        <tbody>
          {list.map((d, index) => (
            <tr key={index}>
              <td>{d.title}</td>
              <td>
                {isNumber(d.progress) ? (
                  <Progress
                    percentage={d.progress}
                    className={styles.progress}
                    showPercentage
                  />
                ) : (
                  <div>
                    <div className={styles.average}>
                      Average: {d.average.toFixed(2)}
                    </div>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

const QUERY = gql`
  query Assignment($id: ID!) {
    assignment(id: $id) {
      id
      stats {
        progress1
        progress2
        progress3
        progress4
        average1
        average2
        average3
      }
    }
  }
`;
